import { ColumnDefinition, ResourceFilter } from '@amzn/dots-core-ui';
import { Configuration } from '../../api';

const ConfigurationColumnDefinitions: ColumnDefinition<Configuration>[] = [
  { id: 'id', header: 'ID', item: (item): number => item.id },
  {
    id: 'name',
    header: 'Name',
    item: (item): string => item.name,
  },
  {
    id: 'feature',
    header: 'Feature',
    item: (item): string => item.featureName,
  },
  { id: 'owner', header: 'Owner', item: (item): string => item.packageOwner },
  {
    id: 'users',
    header: 'Users',
    item: (item): string => item.packageUsers.join(', '),
  },
];

export type ConfigurationColumnDefinitionFiltersFields =
  | 'ids'
  | 'name'
  | '_name'
  | 'packageCreatedBy'
  | 'packageOwner'
  | 'packageUsers'
  | 'config';

export const ConfigurationColumnDefinitionFilters: ResourceFilter[] = [
  { key: 'ids', label: 'Id', type: 'equals' },
  { key: '_name', label: 'Name', type: 'contains', isDefault: true },
  { key: 'packageCreatedBy', label: 'Created By', type: 'equals' },
  { key: 'packageOwner', label: 'Owner', type: 'equals' },
  { key: 'packageUsers', label: 'Users', type: 'equals' },
  {
    key: 'default',
    label: 'Default Config',
    type: 'equals',
    valid: ['true', 'false'],
  },
  { key: 'config', label: 'Config', type: 'contains' },
];

export default ConfigurationColumnDefinitions;
